import { render, staticRenderFns } from "./RegistroRemotoRegrasPage.vue?vue&type=template&id=307a101e"
import script from "./RegistroRemotoRegrasPage.vue?vue&type=script&lang=js"
export * from "./RegistroRemotoRegrasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports